import { memo, useMemo } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Stack, Typography } from '@lyearn/ui';
import { IconTypeEnum } from '@/types/schema';

import ColorPickerList from './components/ColorPickerList';
import EmojiPicker from './components/EmojiPicker';
import { ColorOrEmojiPickerProps } from './types';

const ColorOrEmojiPicker = (props: ColorOrEmojiPickerProps) => {
  const { t } = useTranslation();
  const { className, title = t('Common:ColorOrEmoji'), value, onChange } = props;

  const actions = useMemo(
    () => ({
      onColorChange: (color: string) => onChange({ type: IconTypeEnum.Color, value: color }),
      onEmojiChange: (emoji: string) => onChange({ type: IconTypeEnum.Emoji, value: emoji }),
    }),
    [onChange],
  );

  const color = value.type === IconTypeEnum.Color ? value.value : undefined;
  const emoji = value.type === IconTypeEnum.Emoji ? value.value : undefined;

  return (
    <Stack alignItems="center" className={className} justifyContent="between">
      <Typography color="text-text-primary" variant="body-short-01">
        {title}
      </Typography>
      <Stack alignItems="center" gapX={4}>
        <ColorPickerList value={color} onChange={actions.onColorChange} />
        <EmojiPicker value={emoji} onChange={actions.onEmojiChange} />
      </Stack>
    </Stack>
  );
};

export default memo(ColorOrEmojiPicker);
